import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { downloadProtected } from "@/components/ImportDialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { FileText, Printer, Mail } from "lucide-react";
import { toast } from "sonner";

export const OrcamentoCliente = ({ pedido }) => {
  const [dlg, setDlg] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [dias, setDias] = useState(String(pedido.orc_validade_dias || 15));
  const [cond, setCond] = useState(pedido.orc_condicoes || "Pronto pagamento");
  const guardarConfig = async () => {
    try {
      const { data } = await api.put(`/atendimentos/${pedido.id}/orcamento/config`, { validade_dias: Number(dias) || 15, condicoes: cond });
      setDias(String(data.validade_dias)); setCond(data.condicoes);
    } catch (err) { toast.error(apiError(err)); }
  };
  const nome = `orcamento_${(pedido.codigo || String(pedido.numero)).replace("/", "-")}.pdf`;
  const url = `/atendimentos/${pedido.id}/orcamento.pdf`;

  const descarregar = () => guardarConfig().then(() => downloadProtected(url, nome)).catch((err) => toast.error(apiError(err)));
  const imprimir = async () => {
    const w = window.open("", "_blank");
    try {
      await guardarConfig();
      const res = await api.get(url, { responseType: "blob" });
      w.location.href = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    } catch (err) { w && w.close(); toast.error(apiError(err)); }
  };
  const enviar = async () => {
    setBusy(true);
    try {
      await guardarConfig();
      const { data } = await api.post(`/atendimentos/${pedido.id}/orcamento/enviar`, { email });
      toast.success(`Orçamento enviado para ${data.destino}`);
      setDlg(false);
    } catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };

  return (
    <div className="px-5 py-3 border-t border-slate-100 flex items-center gap-2 flex-wrap" data-testid="orcamento-cliente">
      <span className="text-[10px] uppercase text-slate-400 font-semibold mr-1">Orçamento para o cliente</span>
      <label className="flex items-center gap-1 text-[11px] text-slate-500">Validade
        <Input type="number" min={1} max={365} value={dias} onChange={(e) => setDias(e.target.value)} onBlur={guardarConfig} className="h-7 w-16 text-xs" data-testid="orc-validade-input" />dias
      </label>
      <label className="flex items-center gap-1 text-[11px] text-slate-500">Pagamento
        <Input list="orc-cond-opcoes" value={cond} onChange={(e) => setCond(e.target.value)} onBlur={guardarConfig} className="h-7 w-48 text-xs" data-testid="orc-condicoes-input" />
        <datalist id="orc-cond-opcoes"><option value="Pronto pagamento" /><option value="30 dias após data da fatura" /><option value="50% na adjudicação, restante na entrega" /></datalist>
      </label>
      <Button size="sm" variant="outline" className="h-7 text-xs gap-1.5" onClick={descarregar} data-testid="orc-pdf"><FileText size={13} /> PDF</Button>
      <Button size="sm" variant="outline" className="h-7 text-xs gap-1.5" onClick={imprimir} data-testid="orc-imprimir"><Printer size={13} /> Imprimir</Button>
      <Button size="sm" variant="outline" className="h-7 text-xs gap-1.5" onClick={() => { setEmail(pedido.cliente?.email || ""); setDlg(true); }} data-testid="orc-email"><Mail size={13} /> Enviar por email</Button>
      <Dialog open={dlg} onOpenChange={setDlg}>
        <DialogContent>
          <DialogHeader><DialogTitle>Enviar orçamento por email</DialogTitle></DialogHeader>
          <p className="text-xs text-slate-500">O email leva um botão para abrir o PDF (válido 60 dias), sem referências nem fornecedores. A resposta do cliente chega a geral@blaublits.pt.</p>
          <Input type="email" placeholder="email do cliente" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="orc-email-input" />
          <DialogFooter>
            <Button variant="outline" onClick={() => setDlg(false)}>Voltar</Button>
            <Button disabled={busy || !email.trim()} onClick={enviar} data-testid="orc-email-enviar">{busy ? "A enviar…" : "Enviar"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
